import { defineMessages } from "@formatjs/intl";

const messages = defineMessages({
  detailButton: {
    id: "ShortList.DetailButton",
    defaultMessage: "Learn More",
    description:
      "The label of the button to open property detail on the shortlist",
  },
});

export default messages;
